<div class="flex justify-start items-start gap-4 mb-5">
    <app-avatar [userList]="[{ displayName: this.authService.myName, pic: null }]" [charLength]="2" size="2xl"></app-avatar>
    <div class="border border-[#E3E6EE] rounded-md w-full relative">

      <textarea class="input-field !w-full !resize-none min-h-[120px] text-sm leading-5 py-2.5 px-3 focus:outline-none focus:ring-0 focus:border-[#141414]" placeholder="Write a note.. (Ex: Max 400 characters)"
        rows="5" type="text" id="Code" #messageInput name="Notes" formControlName="description"
        maxlength="400" (keyup)="onInputChange()"></textarea>
      <div class="p-2.5 border-t border-[#E3E6EE] ">
        <div class="flex lg:flex-row flex-col justify-between items-center gap-2 mb-1">

          <div class="lg:w-auto w-full">
            <div *ngIf="isDisplayNotes && isDisplayStatus" class="flex lg:flex-row flex-col items-center gap-2">
              <div class="p-0.5 rounded-md bg-[#54578E12] lg:w-auto w-full">
                <div
                  class="flex items-center justify-center gap-1 bg-[#F9F9F9] p-[3px] rounded-md font-medium text-sm leading-4 text-[#6B7080]">
                  <a href="javascript:void(0)" (click)="setTab('Note')" [ngClass]="activeClass ('Note')"
                    class="border bor hover:border-[#42578A26] px-3 py-1 flex-1 text-center hover:bg-[#FFFFFF] rounded hover:text-[#15191E]">
                    <span>Note</span>
                  </a>
                  <a href="javascript:void(0)" (click)="setTab('Status')" [ngClass]="activeClass ('Status')"
                    class="border hover:border-[#42578A26] px-3 py-1 flex-1 text-center hover:bg-[#FFFFFF] rounded hover:text-[#15191E]">
                    <span>Status</span>
                  </a>
                </div>
              </div>
              @if (activeTab === 'Note' && isDisplayNotes) {
              <div class="lg:w-[200px] w-full"
                [style.pointer-events]="isCompleted ? 'none' : 'auto'"
                [style.opacity]="isCompleted ? '0.6' : '1'">
                <app-select-multilevel [closeOnSelect]="false" [appendToBody]="false"
                      id="Notes"
                      placeHolder="Notes Type"
                      bindLabel="name"
                      [groupBy]="'parentName'"
                      [pageResult]="noteTypeListAll"
                      [initialSelectedValue]="selectedNoteTypeId"
                      (selectionChanged)="onChangeNotes($event)"
                      [clearSelectedValue]="isNoteSavedSuccess"
                      [closeOnSelect]="true"
                    >
                    </app-select-multilevel>
              </div>
              } @else if (isDisplayStatus) {
              <div class="lg:w-[200px] w-full">
                <div class="col-span-1 text-start"
                  [style.pointer-events]="(isCompleted && !isManager) || !ChangeTicketStatusWrite ? 'none' : 'auto'"
                  [style.opacity]="(isCompleted && !isManager) || !ChangeTicketStatusWrite ? '0.6' : '1'">
                  <app-select-multilevel [closeOnSelect]="false" [appendToBody]="false"
                      id="Status"
                      placeHolder="Status"
                      bindLabel="name"
                      [groupBy]="'parentName'"
                      [pageResult]="statusListAll"
                      (selectionChanged)="onChangeStatus($event)"
                      [initialSelectedValue]="selectedCurrentStatusId"
                      [closeOnSelect]="true"
                    >
                    </app-select-multilevel>
                </div>
              </div>
              <div *ngIf="this.isResolutionRequired" class="lg:w-[200px] w-full">
                <div class="col-span-1 text-start"
                  [style.pointer-events]="isCompleted && !isManager ? 'none' : 'auto'"
                  [style.opacity]="isCompleted && !isManager ? '0.6' : '1'">
                  <app-select-multilevel [closeOnSelect]="false" [appendToBody]="false"
                      id="Resolution"
                      placeHolder="Resolution"
                      bindLabel="name"
                      [groupBy]="'parentName'"
                      [pageResult]="resolutionListAll"
                      (selectionChanged)="onChangeResolution($event)"
                      [clearSelectedValue]="isNoteSavedSuccess"
                      [closeOnSelect]="true"
                    >
                    </app-select-multilevel>
                </div>
              </div>
              }
            </div>
          </div>


          <div [style.pointer-events]="isCompleted && isCompletedSelected ? 'none' : 'auto'"
                  [style.opacity]="isCompleted && isCompletedSelected ? '0.6' : '1'" class="flex justify-end items-center gap-2 w-full">
            <bk-button 
              variant="secondary"
              label="Attach"
              (click)="filebtn.click()" 
              [loading]="false"
              size="sm"
              leftIcon="../../../../../../../../assets/images/icons/setup/attachement-black.svg" 
              iconAlt="plus"
              [disabled]="false" 
              buttonClass="text-[#15191E] border-[#E3E6EE] !py-[5px] rounded-md" 
              class="shrink-0">
              Attach
            </bk-button>
            <bk-button 
              variant="primary"
              label="Send"
              (click)="OnSubmit()" 
              [loading]="loading"
              size="sm"
              leftIcon="../../../../../../../../assets/images/icons/setup/update-hover.svg" 
              iconAlt="plus"
              [disabled]="isSaveBtnDisabled || loading" 
              buttonClass="text-white bg-[#141414] !py-[5px] rounded-md" 
              class="shrink-0">
            </bk-button>
          </div>


        </div>
        <div class="flex items-center gap-1 flex-wrap">
            <div *ngFor="let file of lstUploadedFiles; let i = index" matTooltip ="{{file.AttachmentName}}">
              <p class="px-2 py-1 bg-[#EBEBEE] flex items-center justify-center gap-1.5 rounded-2xl cursor-pointer max-w-40">
                <span class="text-[#6f6f6f] font-medium text-xs leading-4 truncate whitespace-nowrap overflow-hidden">
                  {{truncateFileName(file.AttachmentName)}}
                </span>
                <img src="../../../assets/images/icons/global/popup-cross.svg" alt="cross" role="button" tabindex="0" class="size-2" (click)="remove(file.AttachmentName)" (keydown.enter)="remove(file.AttachmentName)">
              </p>
            </div>
        </div>
          <input type="file" hidden multiple #filebtn (change)="handleFileInput($event)"
            accept="jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .heic">
      </div>
      <div class="">
          <div *ngIf="showPopup" class="suggestions_popup max-w-[280px] bg-white absolute top-0 left-0 shadow-sm border border-[#F1F1F4] rounded-xl overflow-hidden" #popupContainer>

            <div class="text-base font-semibold text-[#15191E] p-2 border-b border-[#F1F1F4]">Suggestions</div>

          <hr class="text-gray-400 mb-0">

          <div #listContainer class="list-container max-h-[280px] overflow-y-auto">
            <div *ngFor="let user of filterUserList; let i = index">
              <div [ngClass]="{'selected': i === selectedIndex}">
                <button (click)="onSelectName(user?.fullName,user.id,user?.isRolePerson)" class="mat-menu-item">
                  <span>{{user?.fullName}}</span>
                </button>
              </div>
            </div>
          </div>

          </div>
      </div>
    </div>
  </div>



<div
  class="flex justify-start items-start lg:gap-4 gap-2 mb-5"
  *ngFor="let msg of mongoNotes"
>

  <!-- Avatar -->
  <app-avatar
    [userList]="[
      {
        displayName: msg.createdByUserName,
        pic: msg.createdByUserPic
      }
    ]"
    [charLength]="2"
    size="2xl"
  >
  </app-avatar>

  <div class="grow-1 w-full">

    <!-- HEADER -->
    <div class="flex lg:flex-row flex-col lg:gap-2 gap-1">

      <!-- LEFT INFO -->
      <div class="flex flex-col min-w-36 max-w-36">

        <!-- User Info -->
        <div class="flex flex-col text-[10px] text-[#A9ABB0] font-medium">

          <span class="truncate">
            {{ msg.createdByUserName }}
          </span>

          <span>
            {{ utcToTimeZone.convertUTCToLocalTime(msg.updatedOn, parentTimeZone) | date: 'MM/dd/yy HH:mm' }}
          </span>

        </div>
      </div>

      <!-- DIVIDER -->
      <div
        class="lg:block hidden bg-[#EBEDF3] min-h-8 max-w-[1.5px] min-w-[1.5px]"
      ></div>

      <!-- NOTE TEXT -->
      <div class="flex-1">

        <p class="text-xs text-[#60646C] font-medium break-all">
          {{ msg.noteText }}
        </p>

        <!-- ATTACHMENTS -->
        <div
          *ngIf="msg.attachments?.length"
          class="mt-2 flex flex-wrap gap-2"
        >

          <a
            *ngFor="let attachment of msg.attachments; let i = index"
            class="bg-[#F3F4F6B2] border border-[#EBEBEE] rounded-lg p-2.5 inline-flex items-center gap-2 w-[200px] h-[40px] cursor-pointer"
            (click)="showImageViewer(getAttachmentUrls(msg.attachments), i)"
          >

            <!-- ICON -->
            <img
              [src]="getFileIcon(attachment.attachmentUrl)"
              class="size-4"
            />

            <!-- FILE NAME -->
            <span class="text-xs text-[#60646C] truncate">
              {{ getFileName(attachment.attachmentUrl) }}
            </span>

          </a>

        </div>

      </div>
    </div>

  </div>
</div>










  <!-- //Previous code which work with the sql server -->


  <!-- <div class="flex justify-start items-start lg:gap-4 gap-2 mb-5" *ngFor="let msg of notes">
    <app-avatar [userList]="[{ displayName: msg.userName, pic: msg.userPic }]" [charLength]="2" size="2xl"></app-avatar>
    <div class="grow-1">
      @if (isSelectedTabNotes){
      <div class="flex lg:flex-row flex-col lg:gap-2 gap-1">

        <div class="font-medium text-[#60646C] leading-5 lg:mb-2 flex flex-col min-w-36 max-w-36">
   
          <span class="font-semibold text-[#15191E] truncate text-[13px]">{{ msg?.noteType }}</span>
          
          <div class="flex flex-col font-medium text-[10px] text-[#A9ABB0]">
            <span class="leading-4 truncate">{{ msg.userName }}</span>
            <span class="leading-4">{{ utcToTimeZone.convertUTCToLocalTime(msg.updatedOn, parentTimeZone) | date: 'MM/dd/yy HH:mm'}}</span>
          </div>
        </div>

        <div class="lg:block hidden bg-[#EBEDF3] min-h-8 max-w-[1.5px]  min-w-[1.5px]"></div>
        
        <p class="font-medium text-[#60646C] leading-5 text-xs text-justify break-all">{{msg.noteText}}</p>
      </div>
      } @else {
      <div class="flex lg:flex-row flex-col lg:gap-2 gap-1">

        <div class="font-medium text-[#60646C] leading-5 lg:mb-2 flex flex-col min-w-36 max-w-36">
          
          <span class="font-semibold text-[#15191E] truncate text-[13px]">{{ msg?.noteType }}</span>
          
          <div class="flex flex-col font-medium text-[10px] text-[#A9ABB0]">
            <span class="leading-4 truncate">{{ msg.userName }}</span>
            <span class="leading-4">{{ utcToTimeZone.convertUTCToLocalTime(msg.updatedOn, parentTimeZone) | date: 'MM/dd/yy HH:mm' }}</span>
          </div>
        </div>

      
        <div class="lg:block hidden bg-[#EBEDF3] min-h-8 max-w-[1.5px]  min-w-[1.5px]"></div>
       
        <p class="font-medium text-[#60646C] leading-5 text-xs text-justify break-all">{{msg.noteText}}</p>
      </div>

      }

      <div *ngIf="msg.attachments && msg.attachments.length > 0" class="mt-2 flex flex-wrap gap-2 cursor-pointer">
        <a
          rel="noopener noreferrer"
          *ngFor="let attachment of msg.attachments; let i = index"
          (click)="!loading && showImageViewer(getAttachmentPaths(msg.attachments), i)"
          (keydown.enter)="!loading && showImageViewer(getAttachmentPaths(msg.attachments), i)"
          [class.pointer-events-none]="loading"
          [class.opacity-50]="loading"
          tabindex="0"
          role="button"
          class="bg-[#F3F4F6B2] border border-[#EBEBEE] rounded-lg p-2.5 inline-flex justify-start items-center gap-1.5 w-[200px] h-[40px]"
        >
          <img [src]="getFileIcon(attachment.path)" alt="file icon">
          <p class="text-[#60646C] font-medium text-xs leading-4">
        <span class="">{{ truncateFileName(attachment.path) }}</span>
        <span class="ms-1.5 text-[#A9ABB0] font-medium text-xs before:content-[''] before:inline-block before:size-1 before:me-1 before:rounded-full before:bg-[#A9ABB04D] hidden">742kb</span>
          </p>
          <button class="size-5 rounded-full flex justify-center items-center outline-0 cursor-pointer group shrink-0">
          <img src="../../../../../../assets/images/icons/global/popup-cross.svg" class="hidden" alt="gray cross" height="10" width="10">
          <img src="../../../../../../assets/images/icons/global/popup-cross-white.svg" class="hidden" alt="white cross" height="10" width="10">
          </button>
        </a>
      </div>




    </div>
  </div> -->
